import React, { Component } from 'react';

class PageNotFound extends Component {
  render() {
    return (
      <div className="c-404 u-color-white u-bg-color-solitude u-flex u-flex-column u-justify-content-center u-align-items-center u-flex-1">
        <div className="u-bg-color-border u-border-radius u-padding-large u-flex u-align-items-center u-flex-column">
          <h1 className="u-text-uppercase u-margin-bottom-small">
            Но реп, бро!
          </h1>
          <p>Страницата не е намерена.</p>
          <a className="c-btn c-btn--primary" href="/">
            <span className="u-margin-right-small">←</span>Начало
          </a>
        </div>
      </div>
    );
  }
}

export default PageNotFound;
